import { makeStyles } from "@fluentui/react-components";
import SocialMedia from "./SocialMedia";
import Certifications from "./Certifications";
import Legal from "./Legal";
import ContactDetails from "./contact/ContactDetails";
import Logo from "./Logo";
import Address from "./address/Address";
import { dolphinTokens } from "../../utils/Theme";
import { useEffect, useState } from "react";
import Status from "../../enums/Status";
import IAddress from "../../models/localisation/IAddress";
import addressService from "../../services/AddressService";

const useStyles = makeStyles({
	container: {
		display: 'flex',
		justifyContent: 'center',
		backgroundColor: dolphinTokens.colorDarkBlue,
		color: 'white',
		width: '100%',
		height: 'auto',
		padding: '20px 0',
	},
	footer: {
		maxWidth: "1500px",
		margin: "0 auto",
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		flexDirection: "column",

		'@media (min-width: 600px)': {
			flexDirection: "row",
			gap: "5rem",
		},
	},
	column: {
		flex: 1,
		padding: '20px 0',
		textAlign: 'center',

		'@media (min-width: 600px)': {
			padding: '0 20px',
			textAlign: 'left',
		},
	}
});

const Footer = () => {
	const styles = useStyles();

	const [address, setAddress] = useState<IAddress>(null!);
	const [status, setStatus] = useState<Status>(Status.LOADING);

	const isLoading = status === Status.LOADING;

	useEffect(() => {
		fetchAddress(setAddress, setStatus);
	}, []);

	return (
		<div className={styles.container}>
			<div className={styles.footer}>

				{/* Column 1 - logo & address */}
				<div className={styles.column}>
					<Logo />
					<Address isLoading={isLoading} address={address} />
				</div>

				{/* Column 2 - contact details & socials */}
				<div className={styles.column}>
					<ContactDetails isLoading={isLoading} phone={address?.phone} />
					<SocialMedia />
				</div>

				{/* Column 3 - certifications */}
				<div className={styles.column}>
					<Certifications />
				</div>

				{/* Column 4 - legal */}
				<div className={styles.column}>
					<Legal />
				</div>

			</div>
		</div>
	);
};

export default Footer;

async function fetchAddress(
	setAddress: (address: IAddress) => void,
	setStatus: (status: Status) => void
) {
	try {
		const address = await addressService.getLocalAddress();

		setAddress(address);
		setStatus(Status.LOAD_SUCCESS);
	} catch {
		setStatus(Status.LOAD_ERROR);
	}
}